<template>
  <div class="col">
    <multiselect
      class="mb-2"
      v-show="filteredProgramOptions.length"
      v-model="programSelected"
      :options="filteredProgramOptions"
      :placeholder="$ml.get('selectProgram')"
      :searchable="true"
      label="name"
      :close-on-select="true"
      :show-labels="false"
      :allow-empty="false"
      :preselect-first="true"
      :multiple="false"
    >
    </multiselect>
    <div
      v-if="listProgramSelected.length"
      class="d-flex align-items-center"
      style="gap: 5px; flex-wrap: wrap"
    >
      <div
        v-for="(program, index) in listProgramSelected"
        :key="index"
        class="tagsListReport"
      >
        <span>{{ program.name }}</span>
        <span class="tag-remove" @click="removeProgram(program)">x</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "selectProgram",
  props: ["listProgram", "programSelectedUser"],
  data() {
    return {
      listProgramSelected: [],
      programSelected: "",
    };
  },
  watch: {
    programSelected() {
      if (this.programSelected) {
        this.listProgramSelected = [
          ...this.listProgramSelected,
          this.programSelected,
        ];
        this.sendData();
      }

      this.programSelected = "";
    },
  },
  computed: {
    filteredProgramOptions() {
      let filterIds = this.listProgramSelected.map((it) => it._id);
      return this.listProgram?.filter((item) => !filterIds.includes(item._id));
    },
  },
  methods: {
    removeProgram(program) {
      this.listProgramSelected = this.listProgramSelected.filter(
        (it) => it._id != program._id,
      );
      this.sendData();
      this.programSelected = "";
    },
    sendData() {
      this.$emit("getPrograms", {
        listPrograms: this.listProgramSelected,
      });
    },
  },
  mounted() {
    this.programSelected = null;
    if(this.programSelectedUser?.length){
      this.listProgramSelected = this.programSelectedUser;
      }
  },
};
</script>

